const Genesis = require("../Genesis.js")
import { BlockPageHelper } from "../Helpers/helpers";
import Swal from "sweetalert2";

export class ISiteMobileWorkOrderMaterialListPage {

    public Init() {
        $(".btnDelete").click(function () {
            var materialId = $(this).data('materialid'); 
            var workOrderId = $(this).data('workorderid');
            Swal.fire({
                title: 'Are you sure you want to Delete the Material?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Delete Material'
            }).then((result) => {
                if (result.isConfirmed) {
                    BlockPageHelper.block();
                    $.post(Genesis.url("/WorkOrder/DeleteMaterial"),
                        {
                            materialId: materialId,
                            workOrderId: workOrderId
                        }, function (response) {
                            Swal.fire("Success", "The Material was Deleted successfully.")
                            location.reload();
                        }).fail(() => {
                            Swal.fire("Failed", "There was an error Deleting Material. Please try again.")
                        }).
                        always(() => {
                            BlockPageHelper.unblock();
                        });
                }
            })
        });
    }

};